<template>
    <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card :title="data.title">
            <template slot="actions">
                <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
            </template>

            <!-- CHART -->
            <template slot="no-body">
                <div class="mt-10">
                    <vue-apex-charts type=radialBar height=240 :options="data.chartData.chartOptions" :series="data.chartData.series" />
                </div>
            </template>

            <!-- DATA -->
            <div class="flex justify-between text-center mt-6" slot="no-body-bottom">
                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <p class="mt-4">Completed</p>
                    <p class="mb-4 text-3xl font-semibold">{{data.chartData.analyticsData.completed}}</p>
                </div>
                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                    <p class="mt-4">In Progress</p>
                    <p class="mb-4 text-3xl font-semibold">{{data.chartData.analyticsData.inProgress}}</p>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

    import VueApexCharts from 'vue-apexcharts'

    export default {
        name: "radial-chart",
        props: {
            data: Object
        },
        components: {
            VueApexCharts
        }
    };
</script>
